import { EntityStateViewName } from '@engoo/realtime-protocol/entityState';
import { KeyPath } from 'app/models/entityStateSync/keypath';
import { KeyPathRootState, KeyPathState } from 'app/models/entityStateSync/types';

export const getKeyPathState = <T extends EntityStateViewName>(
  keyPathRootState: KeyPathRootState,
  viewName: T,
  keyPath: KeyPath,
): KeyPathState<T> | undefined => {
  const keyPathRootStateMap = keyPathRootState.get(viewName);
  // Need to use a type assertion to convince typescript that the type can be
  // narrowed to just the type associated with the given `viewName`.
  return keyPathRootStateMap && (keyPathRootStateMap.get(keyPath) as KeyPathState<T>);
};

export const chatAttachmentExpanded = (
  keyPathRootState: KeyPathRootState,
): boolean => {
  const chatAttachmentStateStateMap = keyPathRootState.get(EntityStateViewName.ChatAttachment);
  return chatAttachmentStateStateMap.valueSeq().some((val) => (
    val?.expandedAttachmentId !== undefined
  ));
};
